var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFundacao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.783,
    height: 51.252,
    viewBox: "0 0 62.783 51.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_984",
    "data-name": "Grupo 984",
    transform: "translate(-449.458 -616.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_970",
    "data-name": "Grupo 970",
    transform: "translate(461.703 617.648)",
    opacity: 0.346
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M2.262,25.578,14.62,32.713a4.523,4.523,0,0,1,1.656,6.179l-4.47,7.741H36.119a4.524,4.524,0,0,0,3.918-2.262l9.895-17.137a4.524,4.524,0,0,0-1.656-6.179L35.918,13.92a4.524,4.524,0,0,1-1.657-6.18L38.73,0H14.418A4.523,4.523,0,0,0,10.5,2.262L.606,19.4a4.524,4.524,0,0,0,1.656,6.179",
    transform: "translate(0)",
    fill: "#d9d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_969",
    "data-name": "Grupo 969",
    transform: "translate(-255.396 135.875)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_293",
    "data-name": "Linha 293",
    x2: 12.068,
    transform: "translate(705.605 492.221)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_294",
    "data-name": "Linha 294",
    x2: 12.068,
    transform: "translate(740.631 492.221)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6284",
    "data-name": "Caminho 6284",
    d: "M718.228,481.772V509.44h-6.034v16.63h34.585V509.44h-5.592V481.772",
    transform: "translate(-0.555)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_167",
    "data-name": "Elipse 167",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(712.315 498.495)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_168",
    "data-name": "Elipse 168",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(705.935 496.068)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_169",
    "data-name": "Elipse 169",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(708.539 504.922)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_170",
    "data-name": "Elipse 170",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(705.935 514.593)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_171",
    "data-name": "Elipse 171",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(706.932 528.488)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_172",
    "data-name": "Elipse 172",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(721.099 529.15)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_173",
    "data-name": "Elipse 173",
    cx: 1.056,
    cy: 1.056,
    r: 1.056,
    transform: "translate(737.242 530.163)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_174",
    "data-name": "Elipse 174",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(746.665 528.488)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_175",
    "data-name": "Elipse 175",
    cx: 1.056,
    cy: 1.056,
    r: 1.056,
    transform: "translate(753.371 518.625)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_176",
    "data-name": "Elipse 176",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(742.947 495.071)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_177",
    "data-name": "Elipse 177",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(750.071 498.354)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_178",
    "data-name": "Elipse 178",
    cx: 0.997,
    cy: 0.997,
    r: 0.997,
    transform: "translate(749.074 507.918)",
    fill: "#48af77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6285",
    "data-name": "Caminho 6285",
    d: "M721.937,483.982V514h-6.768",
    transform: "translate(-0.806 -0.186)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6286",
    "data-name": "Caminho 6286",
    d: "M746.047,514h-6.733V483.982",
    transform: "translate(-2.841 -0.186)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6287",
    "data-name": "Caminho 6287",
    d: "M715.169,526.762h28.843",
    transform: "translate(-0.806 -3.791)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_295",
    "data-name": "Linha 295",
    x2: 15.342,
    transform: "translate(721.131 503.921)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_296",
    "data-name": "Linha 296",
    x2: 15.342,
    transform: "translate(721.131 494.834)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_297",
    "data-name": "Linha 297",
    x2: 15.342,
    transform: "translate(721.131 485.452)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_298",
    "data-name": "Linha 298",
    y2: 9.152,
    transform: "translate(716.274 513.818)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_299",
    "data-name": "Linha 299",
    y2: 9.152,
    transform: "translate(741.551 513.818)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_300",
    "data-name": "Linha 300",
    x2: 17.329,
    transform: "translate(720.579 513.818)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6288",
    "data-name": "Caminho 6288",
    d: "M715.169,519.634H722.1a3.256,3.256,0,0,0,3.255-3.256v-32.4",
    transform: "translate(-0.806 -0.186)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6289",
    "data-name": "Caminho 6289",
    d: "M746.534,519.634H739.6a3.256,3.256,0,0,1-3.256-3.256v-32.4",
    transform: "translate(-2.591 -0.186)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundacao);
export default __webpack_public_path__ + "static/media/fundacao.19177813b128c5992af4f02485f78c7a.svg";
export { ForwardRef as ReactComponent };